
export const SignatureElement = ({ value, height = 200 }) => {
    return (
        value ? <img height={height} src={`data:image/png;base64,${value}`} /> : <></>
    )
}